module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.block]
  }, [_c('SpotinHeader'), _vm._v(" "), (!_vm.isFetchingData) ? _c('div', {
    class: [_vm.block + '-dynamicContent']
  }, [_c('div', {
    class: [_vm.block + '-flex']
  }, [_c('FixedContainer', [_c('FixedSections')], 1), _vm._v(" "), _c('ScrolledSections')], 1), _vm._v(" "), _c('Sections'), _vm._v(" "), _c('SpotinFooter')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-760c3de7","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/combinedBlocks/Website.vue
// module id = 605
// module chunks = 0